import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import Squiggle from '../squiggle'

import s from './style.module.scss'

class Home extends React.Component {
  render() {
    const h1_style = {
      fontSize:
        Math.min(
          Math.max(
            typeof window !== 'undefined'
              ? window.innerWidth / 100 * 8
              : 1200 / 100 * 8
          ),
          86
        ) + 'px'
    }

    const dot = (
      <div className={s.dot}>
        <svg viewBox="0 0 10 10" fill="currentColor">
          <circle cx="5" cy="5" r="5" />
        </svg>
      </div>
    )

    const large_squiggle_size = 252
    const small_squiggle_size = 72

    let h1 = (
      <h1 className={s.heading} style={h1_style}>
        Betsy <span className={s.ampersand}>&</span> Thomas{' '}
        <span
          style={{
            position: 'relative',
            left: '8px',
            display: 'inline-block'
          }}>
          got married.
        </span>
      </h1>
    )

    if (
      (this.props.hostname && this.props.hostname === 'thomasandbetsy.com') ||
      this.props.hostname === 'www.thomasandbetsy.com'
    ) {
      h1 = (
        <h1 className={s.heading} style={h1_style}>
          Thomas <span className={s.ampersand}>&</span> Betsy{' '}
          <span
            style={{
              position: 'relative',
              left: '8px',
              display: 'inline-block'
            }}>
            got married.
          </span>
        </h1>
      )
    }

    return (
      <div className={s.outerContainer}>
        <div
          className={s.container}
          data-loaded={typeof window !== 'undefined' && window.innerWidth > 0}>
          <div className={s.headerContainer}>{h1}</div>

          <Squiggle height={large_squiggle_size} />

          <div className={s.blurb}>
            <div>Saturday, August 12, 2017</div>
            <div className={s.detail}>Six o’clock in the evening</div>
            <Squiggle height={small_squiggle_size} />
            <a href="http://bkwinery.com/" className={s.information_section}>
              <div>Brooklyn Winery</div>
              <div className={s.detail}>Brooklyn, New York</div>
            </a>
            <Squiggle height={small_squiggle_size} />
            <div className={s.information_section}>
              <div className={s.accommodations_detail}>Accommodations</div>
              <div className={s.hotel}>
                Out-of-town guests can reserve a room at the{' '}
                <a href="https://aws.passkey.com/event/48971128/owner/13490/home">
                  Marriott Brooklyn Bridge
                </a>. Shuttles to and from the wedding ceremony will be
                provided.
              </div>
            </div>

            <Squiggle height={small_squiggle_size} />

            <div className={s.information_section}>
              <div className={s.accommodations_detail}>Map</div>
              <div className={s.map}>
                For those staying at the hotel or nearby, we made a{' '}
                <Link to="/map">map of the neighborhood</Link>.
              </div>
            </div>

            <Squiggle height={small_squiggle_size} />
            <div className={s.information_section}>
              <div className={s.accommodations_detail}>Parking</div>
              <div className={s.hotel}>
                We recommend two lots a short walk’s distance from the winery:
                568&nbsp;Union Avenue and 544&nbsp;Union Avenue.
              </div>
            </div>

            <Squiggle height={small_squiggle_size} />
            <div className={s.information_section}>
              <div className={s.accommodations_detail}>Registry</div>
              <div className={s.hotel}>
                We’ve set up a{' '}
                <a href="https://www.blueprintregistry.com/registry/betsyandthomas">
                  gift registry
                </a>.
              </div>
            </div>

            <Squiggle height={large_squiggle_size} />

            <Img
              outerWrapperClassName={s.imageWrapper}
              className={s.image}
              sizes={this.props.headerImage.sizes}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/home/index.js